import type { FiltersConfig } from '@rocco/ui/filter-sort/types/filter-config-section';

/**
Professional filters configuration
Note: The order of filters in this configuration is important because it determines the sequence in which filters are applied and displayed.
This can affect both the user interface and the logic that processes these filters.
 **/
export const PROFESSIONAL_FILTERS_CONFIG: FiltersConfig = {
    resultName: 'Professional',
    barFilters: [
        {
            title: 'Location',
            minContentWidth: 20,
            filters: [
                {
                    type: 'default',
                    filterKey: 'searchLocation',
                },
            ],
        },
        {
            title: 'Business focus',
            filters: [
                {
                    type: 'default',
                    filterKey: 'businessFocuses',
                },
            ],
        },
    ],

    modalFilters: [
        {
            title: 'Location',
            collapsable: true,
            collapsedByDefault: false,
            filters: [
                {
                    type: 'default',
                    filterKey: 'searchLocation',
                },
            ],
        },
        {
            title: 'Business Focus',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'businessFocuses',
                },
            ],
        },
        {
            title: 'Projects listed on ArchiPro',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'projectCount',
                },
            ],
        },
        {
            title: 'Featured',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'hasAwards',
                    label: 'Award winning Professionals',
                },
            ],
        },
        {
            title: 'Associations',
            collapsable: true,
            collapsedByDefault: true,
            filters: [
                {
                    type: 'multiple',
                    filterKey: 'associations',
                    columns: 1,
                },
            ],
        },
        {
            title: 'Staff admin filters',
            collapsable: true,
            collapsedByDefault: true,
            adminOnly: true,
            filters: [
                {
                    type: 'default',
                    filterKey: 'invalidLink',
                    label: 'Invalid Link',
                },
                {
                    type: 'default',
                    filterKey: 'noCategory',
                    label: 'Uncategorised',
                },
                {
                    type: 'default',
                    filterKey: 'disabled',
                    label: 'Disabled',
                },
            ],
        },
    ],
};
